import React from 'react';
import PropTypes from 'prop-types';
import RenderDateInputField from 'components/form/InputFields/RenderDateInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import RenderPercentageInputField from 'components/form/InputFields/RenderPercentageInputField';
import dateUtils from 'helpers/dateUtils';
import utils from 'helpers/utils';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';

const DiscountCodesCreateForm = (props, context) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                choices={
                                    [
                                        {
                                            label: translate('resources.discount_codes.components.type.choices.multi'),
                                            value: 'multi',
                                        },
                                        {
                                            label: translate('resources.discount_codes.components.type.choices.single'),
                                            value: 'single',
                                        },
                                        {
                                            label: translate('resources.discount_codes.components.type.choices.wallet'),
                                            value: 'wallet',
                                        },
                                    ]
                                }
                                component={ RenderAutoCompleteInputField }
                                label={ translate('resources.discount_codes.fields.type') }
                                name='type'
                                optionText='label'
                                optionValue='value'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.discount_codes.fields.token') }
                                name='token'
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderBooleanInputField }
                                fullWidth={ true }
                                label={ translate('resources.discount_codes.fields.is_enabled') }
                                name='is_enabled'
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderDateInputField }
                                label={ translate('resources.discount_codes.fields.expiry_date') }
                                name='expiry_date'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderPercentageInputField }
                                fullWidth={ true }
                                label={ translate('resources.discount_codes.fields.percentage') }
                                name='percentage'
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                choices={
                                    utils.map(context.config.currency.supported, (currency) => {
                                        return {
                                            label: currency,
                                            value: currency,
                                        };
                                    })
                                }
                                component={ RenderAutoCompleteInputField }
                                label={ translate('resources.discount_codes.fields.currency') }
                                name='currency'
                                optionText='label'
                                optionValue='value'
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.discount_codes.fields.amount') }
                                name='amount'
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton
                                disabled={ pristine || submitting || invalid }
                                loading={ submitting }
                            />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

DiscountCodesCreateForm.contextTypes = {
    config: PropTypes.object,
};

DiscountCodesCreateForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        initialValues: {
            expiry_date: dateUtils.getActualDate(),
            is_enabled: false,
        },
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.user_id) {
                errors.user_id = translate('forms.required');
            }

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(DiscountCodesCreateForm);



// WEBPACK FOOTER //
// ./src/pages/discountCodes/create/DiscountCodesCreateForm.js